/* eslint-disable no-magic-numbers */
import { useCallback } from 'react';
import styled from 'styled-components';
import { Icon, IconName } from '../../icon';

const StyledItemLabel = styled.span<{ $canRemove?: boolean, $size?: 'default' | 'small' }>`
	border-radius: ${props => props.$size === 'small' ? 10 : 14}px;
	display: flex;
	align-items: center;
	background-color: ${props => props.theme.form.multiSelectInput.itemBackground};
	padding: ${props => props.$size === 'small' ? '2px' : '3px'} 
		${props => props.$canRemove ? (props.$size === 'small' ? 4 : 6) : (props.$size === 'small' ? 6 : 10)}px 
		${props => props.$size === 'small' ? '2px' : '3px'} 
		${props => props.$size === 'small' ? 6 : 10}px;
	height: ${props => props.$size === 'small' ? 18 : 22}px;
	font-size: ${props => props.$size === 'small' ? 11 : 13}px;
	line-height: 1;
	text-overflow: ellipsis;
	overflow: hidden;
	column-gap: ${props => props.$size === 'small' ? 4 : 6}px;
	box-sizing: border-box;
`;

const StyledIcon = styled(Icon)<{ $size?: 'default' | 'small' }>`
	display: flex;
	align-items: center;
	font-size: ${props => props.$size === 'small' ? 11 : 13}px;
	color: ${props => props.theme.form.multiSelectInput.itemColor};
`;

const StyledIconButton = styled(Icon)<{ $size?: 'default' | 'small' }>`
	padding: 0;
	border: 0;
	background-color: transparent;
	color: ${props => props.theme.form.multiSelectInput.removeIcon};
	cursor: pointer;
	font-size: ${props => props.$size === 'small' ? 12 : 15}px;
	display: flex;
	align-items: center;

	&:hover {
		color: ${props => props.theme.form.multiSelectInput.removeIconHover};
	}
`;

const StyledName = styled.span`
	text-overflow: ellipsis;
	overflow: hidden;
	color: ${props => props.theme.form.multiSelectInput.itemColor};
	line-height: 1;
	display: block;
`;

type SimpleInputChipProps = {
	value: string;
	label?: string;
	icon?: IconName;
	onRemove: (value: string) => void;
	canRemove?: boolean;
	size?: 'default' | 'small';
};

export function SimpleInputChip({ value, label, icon, onRemove, canRemove, size = 'default' }: SimpleInputChipProps) {
	const onCrossClick = useCallback((e: React.MouseEvent) => {
		e.stopPropagation();
		onRemove(value);
	}, [value, onRemove]);

	return (
		<StyledItemLabel $canRemove={canRemove} $size={size}>
			{icon && <StyledIcon icon={icon as IconName} $size={size} />}
			<StyledName>{label || value}</StyledName>
			{canRemove && <StyledIconButton icon={'x-circle-solid'} onClick={onCrossClick} $size={size} />}
		</StyledItemLabel>
	);
}

